import DataSubjectAccessRequestEvidenceService from '../services/dsar-evidence-service';

export const dataSubjectAccessRequestEvidence = {
  namespaced: true,
  state: {
    evidences: null,
    evidence: null,
  },
  actions: {
    newEvidence({ commit }, dsarId) {
      const template = {
        description: '',
        evidenceType: '',
        filename: '',
        link: '',
        dateOfEvidence: new Date(),
        startTime: '',
        endTime: '',
        callDuration: '',
        isPhoneCallChecked: false,
      };
      const empty = JSON.parse(JSON.stringify(template));
      empty.dsarId = dsarId;
      commit('setEvidence', empty);
    },
    evidenceList({ commit }, dsarId) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestEvidenceService.evidenceList(dsarId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setEvidences', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    createEvidence({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestEvidenceService.create(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getEvidence({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setEvidence', null);
      return DataSubjectAccessRequestEvidenceService.get(
        payload.dsarId,
        payload.dsarEvidenceId,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setEvidence', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    updateEvidence({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestEvidenceService.update(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    deleteEvidence({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DataSubjectAccessRequestEvidenceService.delete(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setEvidences(state, newEvidences) {
      state.evidences = newEvidences;
    },
    setEvidence(state, newEvidence) {
      state.evidence = newEvidence;
      if (state.evidence) {
        state.evidence.dateOfEvidence = new Date(state.evidence.dateOfEvidence);
      }
    },
  },
};
